import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { login } from '../../redux/authSlice';

const Index = () => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: '',
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { company } = useParams();
  const { isAuthenticated, error, user, loading } = useSelector(
    (state) => state.auth
  );

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await dispatch(login(credentials));
  };

  useEffect(() => {
    if (isAuthenticated && user) {
      navigate(`/${company}/admin`);
    }
  }, [isAuthenticated, user, navigate, company]);

  return (
    <div className='login page'>
      <div className='container'>
        <h2>Inicio de sesión de administrador</h2>
        <form
          onSubmit={handleSubmit}
          className='login-form'>
          <div className='form-group'>
            <label htmlFor='email'>Correo electrónico</label>
            <input
              type='email'
              id='email'
              name='email'
              placeholder='Correo electrónico'
              value={credentials.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className='form-group'>
            <label htmlFor='password'>Contraseña</label>
            <input
              type='password'
              id='password'
              name='password'
              placeholder='Contraseña administrador'
              value={credentials.password}
              onChange={handleChange}
              required
            />
          </div>
          {error && <p className='error'>{error}</p>}
          <button
            className='btn primary'
            type='submit'
            disabled={loading}>
            {loading ? 'Cargando...' : 'Iniciar sesión'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Index;
